import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";

import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01";

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Inquery() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const fileRef = useRef();

    const [focusInput1, setFocusInput1] = useState(false);
    const [focusInput2, setFocusInput2] = useState(false);
    const [focusInput3, setFocusInput3] = useState(false);
    const [focusInput4, setFocusInput4] = useState(false);
    const [focusInput5, setFocusInput5] = useState(false);

    const [inquiryAgreeValue, setInquiryAgreeValue] = useState(false);
    const [inquiryAgreeView, setInquiryAgreeView] = useState(0);

    const [uploadFile, setUploadFile] = useState(null);

    const [idValue, setIdValue] = useState('');
    const [idErr, setIdErr] = useState(0);

    const [qna, setQna] = useState([]);
    const [checkedQna, setCheckedQna] = useState([]);

    const getQna = async () => {
        try {
            const response = await API.get('etc/qna');
            console.log('getQna response:', response);
            setQna(response.data);
        } catch (error) {
            console.log('getQna Error:', error);
        }
    };

    useEffect(() => {
        getQna();
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size > 25 * 1024 * 1024) {
                alert(lang === 0 ? "파일 용량은 25MB 이하만 업로드 가능합니다." : "File size must be 25MB or less.");
                return;
            }
            dispatch(loadingStart());
            setUploadFile(file);
            dispatch(loadingEnd());
        }
    };

    const removeFile = () => {
        setUploadFile(null);
    };

    const formatFileSize = (size) => {
        return (size / (1024 * 1024)).toFixed(2);
    };

    const checkboxFunc = (event, qna) => {
        const { checked } = event.target;
        if (checked) {
            setCheckedQna((prev) => {
                // 동일한 id가 존재하지 않을 때만 추가
                if (!prev.some((item) => item.id === qna.id)) {
                    return [...prev, qna];
                }
                return prev;
            });
        } else {
            setCheckedQna((prev) => prev.filter((item) => item.id !== qna.id));
        }
    };

    const agreeboxFunc = (event) => {
        const { id, checked } = event.target;

        if (id === 'inquiry_agree1') {
            setInquiryAgreeValue(checked)
        }

    }

    const privacy = [`개인정보 수집 이용 동의
• 개인정보 수집 목적 : 주식회사 유모델러는 고객문의 및 상담, 고지사항 전달 등을 위해 아래와 같이 개인정보를 수집·이용합니다.
• 개인정보 수집항목 :  이름, 이메일, 소속, 직책
• 보유 및 이용기간 : 수집일로부터 1년귀하는 개인정보 수집 및 이용에 동의하지 않을 권리가 있으며, 동의하지 않을 경우 문의 접수가 제한될 수 있습니다`,
        `Consent to the Collection and Use of Personal Information
• Purpose of Collection: UModeler Inc. collects and uses personal information for the purposes of handling customer inquiries and consultations, and delivering important notifications.
• Items Collected: Full name, email address, affiliation, and position
• Retention and Usage Period: One year from the date of collection
You have the right to withhold consent to the collection and use of your personal information. However, please be advised that failure to provide consent may limit your ability to submit inquiries.`];

    const inquiryFunc = () => {
        if (!inquiryAgreeValue) {
            setInquiryAgreeView(1);
        } else {
            const name = document.querySelector('.inq_input[name="name"]')?.value || '';
            const email = !mbData?.idx ? idValue : mbData?.mb_email;
            const affiliation = document.querySelector('.inq_input[name="affiliation"]')?.value || '';
            const position = document.querySelector('.inq_input[name="position"]')?.value || '';
            const message = document.querySelector('textarea.inq_textarea')?.value || '';

            // FormData 생성
            const formData = new FormData();
            formData.append('name', name);
            formData.append('email', email);
            formData.append('affiliation', affiliation);
            formData.append('position', position);
            formData.append('message', message);
            formData.append('qna', JSON.stringify(checkedQna));

            if (uploadFile) {
                console.log("uploadFile : ", uploadFile);
                formData.append('attachment', uploadFile, uploadFile.name);
            }

            dispatch(open({
                component:
                    <Popup01
                        text1={lang === 0 ? '문의를 남기시겠습니까?' : 'Would you like to leave an inquiry?'}
                        button={lang === 0 ? '확인' : 'OK'}
                        buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                        setFunc={async () => {
                            dispatch(loadingStart());
                            try {
                                const response = await API.multipart('etc/inquiry', formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                    },
                                });
                                console.log('Inquiry saved:', response);
                                localStorage.setItem('inqSuc', '1');
                                dispatch(loadingEnd());
                                navigate(routes.Support);
                                window.scrollTo(0, 0);
                            } catch (error) {
                                console.error('Inquiry save failed:', error);
                                dispatch(loadingEnd());
                                alert('문의 저장에 실패했습니다.');
                            }
                        }}
                    />
            }));
        }
    };

    const InputChange = (event) => {
        const { name, value } = event.target;
        if (name === "login_id") {
            let EmailChk = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            setIdValue(value);
            if (!EmailChk.test(value)) {
                setIdErr(1);
                return;
            } else {
                setIdErr(0);
            }
        }
    };

    return (
        <>
            <div className="main_back inquiry">
                <div className="inquiry_header">
                    <div className="title_box">
                        <p>{lang === 0 ? '문의하기' : 'Contact Us'}</p>
                        <span>{lang === 0 ? '문의를 남겨주시면 빠른 시간내로 연락을 드립니다.' : 'If you leave an inquiry, we will get back to you as soon as possible.'}</span>
                    </div>
                </div>

                <div className="inquiry_part send">
                    <div className="inquiry_box chk">
                        <div className={`title_box ${lang === 1 ? 'inqu_eng' : ''}`}>
                            <p className="title">{lang === 0 ? '어떤 점이 궁금하신가요?' : 'What are you curious about?'}</p>
                            <span className="sub_title">({lang === 0 ? '중복 선택 가능' : 'Redundant selection is possible'})</span>
                        </div>
                        <div className="chk_box">
                            {qna.map((q, i) => (
                                <div className="custom_chk_box inquiry" key={i} >
                                    <input
                                        type="checkbox"
                                        className="custom_chk_input"
                                        id={`inquiry_chk${i + 1}`}
                                        checked={checkedQna.includes(q)}
                                        onChange={(e) => checkboxFunc(e, q)}
                                    />
                                    <label htmlFor={`inquiry_chk${i + 1}`} className="custom_chk_label">
                                        {lang === 0 ? q.name : q.eng ? q.eng : q.name}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="inquiry_box">
                        <div className="title_box">
                            <p className="title">{lang === 0 ? '이름을 입력해 주세요.' : 'Please enter your name.'}</p>
                        </div>

                        <input
                            type="text"
                            placeholder={lang === 0 ? '이름을 입력해 주세요.' : 'Please enter your name.'}
                            className={`inq_input ${focusInput1 ? 'on' : ''}`}
                            onFocus={() => setFocusInput1(true)}
                            onBlur={() => setFocusInput1(false)}
                            maxLength={10}
                            name="name"
                        />
                    </div>

                    <div className="inquiry_box">
                        <div className="title_box">
                            <p className="title">{lang === 0 ? '이메일' : 'Email'}</p>
                            <span
                                className="input_aster email"
                                style={{
                                    left: lang === 0 ? '54px' : '52px',
                                    top: '0'
                                }}
                            >
                                *
                            </span>
                        </div>

                        {!mbData?.idx ?
                            <>
                                <input
                                    type="text"
                                    placeholder={lang === 0 ? '이메일을 입력해 주세요.' : 'Please enter your Email.'}
                                    className={`inq_input ${focusInput2 ? 'on' : ''}`}
                                    onFocus={() => setFocusInput2(true)}
                                    onBlur={() => setFocusInput2(false)}
                                    value={idValue}
                                    onChange={InputChange}
                                    name="login_id"
                                />
                                {idErr === 1 && <span className="err_msg id">{lang === 0 ? '유효한 이메일 주소를 입력해 주세요.' : 'Please enter a valid email.'}</span>}
                            </>
                            :
                            <input
                                type="text"
                                placeholder={lang === 0 ? '이메일을 입력해 주세요.' : 'Please enter your Email.'}
                                className="inq_input login"
                                value={mbData?.mb_email}
                                readOnly
                            />
                        }
                    </div>

                    <div className="inquiry_box">
                        <div className="title_box">
                            <p className="title">{lang === 0 ? '소속명(회사, 학교 등)' : 'Affiliation(Company, School, etc.)'}</p>
                        </div>

                        <input
                            type="text"
                            placeholder={lang === 0 ? "소속을 입력해 주세요." : 'Please enter your Affiliation.'}
                            className={`inq_input ${focusInput3 ? 'on' : ''}`}
                            onFocus={() => setFocusInput3(true)}
                            onBlur={() => setFocusInput3(false)}
                            name="affiliation"
                        />
                    </div>

                    <div className="inquiry_box">
                        <div className="title_box">
                            <p className="title">{lang === 0 ? '직책' : 'Position'}</p>
                        </div>

                        <input
                            type="text"
                            placeholder={lang === 0 ? "직책을 입력해 주세요." : 'Please enter your Position.'}
                            className={`inq_input ${focusInput4 ? 'on' : ''}`}
                            onFocus={() => setFocusInput4(true)}
                            onBlur={() => setFocusInput4(false)}
                            name="position"
                        />
                    </div>

                    <div className="inquiry_box">
                        <div className={`title_box ${lang === 1 ? 'inqu_eng' : ''}`}>
                            <p className="title">{lang === 0 ? '내용' : 'Message'}</p>
                            <span
                                className="input_aster con"
                                style={{
                                    left: lang === 0 ? '37px' : '85px',
                                    top: '0'
                                }}
                            >
                                *
                            </span>
                        </div>

                        <textarea
                            className={`inq_textarea inq_input ${focusInput5 ? 'on' : ''}`}
                            placeholder={lang === 0 ? "문의 내용을 입력해 주세요." : 'Please enter your inquiry.'}
                            onFocus={() => setFocusInput5(true)}
                            onBlur={() => setFocusInput5(false)}
                        ></textarea>
                    </div>

                    <div className="inquiry_box upload">
                        <div className="title_box file">
                            <p className="title">{lang === 0 ? '첨부파일' : 'Attachment'}</p>
                            <span className="sub_title">
                                ({lang === 0 ? '25mb 이하 / 이미지, 문서파일, 압축파일만 가능' : 'Under 25mb / Image, document files, and compressed files only'})
                            </span>
                        </div>

                        <button
                            type="button"
                            className="upload_btn"
                            onClick={() => fileRef.current.click()}
                        >
                            <img src={require("../../assets/icon/add-line-blue.svg").default} />
                            {lang === 0 ? '파일 업로드' : 'Upload File'}
                        </button>

                        <input
                            ref={fileRef}
                            type="file"
                            style={{ display: "none" }}
                            value={''}
                            accept=".doc, .docx, .xls, .xlsx, .ppt, .pptx, .hwp, .pdf, .gif, .jpg, .jpeg, .png, .zip, .rar, .7z, .alz"
                            onChange={handleFileChange}
                        />

                        {uploadFile && (
                            <div className="file_box">
                                <span>{uploadFile.name} ({formatFileSize(uploadFile.size)} MB)</span>
                                <img
                                    src={require("../../assets/images/exit-icon.svg").default}
                                    onClick={removeFile}
                                />
                            </div>
                        )}
                    </div>

                    <div className="inquiry_box agree">
                        <div className="custom_chk_box inquiry agree">
                            <input
                                type="checkbox"
                                className="custom_chk_input"
                                id="inquiry_agree1"
                                onChange={agreeboxFunc}
                            />
                            <label htmlFor="inquiry_agree1" className="custom_chk_label">
                                {lang === 0 ? '개인정보 수집 및 이용에 동의합니다.' : 'Agree to data collection.'}
                                <span>({lang === 0 ? '필수' : 'Required'})</span>
                            </label>
                        </div>

                        <div className="inq_input agree" style={{ whiteSpace: 'pre-wrap' }}>
                            <p>{privacy[lang]}</p>
                        </div>

                        {inquiryAgreeView == 1 && (
                            <span className="err_msg">
                                {lang === 0
                                    ? '개인정보 수집 및 이용에 동의 체크해 주세요.'
                                    : 'Please check the box to agree to the collection and use of personal information.'}
                            </span>
                        )}
                    </div>

                    <div className="inquiry_box suc">
                        <button
                            type="button"
                            className={`suc_btn ${inquiryAgreeValue ? 'on' : ''}`}
                            onClick={inquiryFunc}
                        >
                            {lang === 0 ? '완료' : 'Submit'}
                        </button>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{
                    width: isBrowser ? 400 : '100%',
                    marginBottom: isBrowser ? 60 : 70,
                }}
                hideProgressBar
            />
        </>
    );
}